// extracted by mini-css-extract-plugin
export const wrapper = "IrrigationPlans-module--wrapper--5Zrw9";
export const graphic = "IrrigationPlans-module--graphic--3i02Y";
export const icon = "IrrigationPlans-module--icon--2JWdL";
export const graphicWrapper = "IrrigationPlans-module--graphicWrapper--2ni2e";